module.exports = __webpack_public_path__ + "static/img/head-pt.857fed0b.png";